export var DsgStorageTier;
(function (DsgStorageTier) {
    DsgStorageTier["DSG_STORAGE_TIER_STANDARD"] = "STANDARD";
    DsgStorageTier["DSG_STORAGE_TIER_NEARLINE"] = "NEARLINE";
    DsgStorageTier["DSG_STORAGE_TIER_COLDLINE"] = "COLDLINE";
    DsgStorageTier["DSG_STORAGE_TIER_ARCHIVE"] = "ARCHIVE";
})(DsgStorageTier || (DsgStorageTier = {}));
